import { render } from "./WinsDistributionGraph.vue?vue&type=template&id=717a716c&scoped=true&ts=true"
import script from "./WinsDistributionGraph.vue?vue&type=script&lang=ts"
export * from "./WinsDistributionGraph.vue?vue&type=script&lang=ts"

import "./WinsDistributionGraph.vue?vue&type=style&index=0&id=717a716c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\breno\\Documents\\Workspace\\Coll\\palavra-quadrada\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-717a716c"]])

export default __exports__